<template>
  <aside id="description">
    <p><slot></slot></p>
  </aside>
</template>
<script>
export default {
  name: 'Description'
}
</script>
<style lang="scss" scoped>
#description {
  padding: 0 15px;
  margin: 0 0 10px 0;
  p {
    font-size: 18px;
    margin: 0;
  }
}
@media(min-width:767px) {
  #description {
    padding: 0 40px;
    p {
      font-size: 20px;
    }
  }
}
@media (min-width:767px) and (min-height: 620px) {
  #description {
    margin: 5px 0 20px 0;
  }
}

@media (min-width:767px) and (min-height: 820px) {
  #description {
    margin: 10px 0 25px 0;
  }
}
</style>
